export class OfferModel {
  term: string;
  loanAmount = 0;
  quoteId: any;
  myBenefits: boolean;
  firstPaymentDate: string;
  payoutMethod: string;
  interestRate: string | number = 5;
  disbursedAmount = 0;
  settlementAmount = 0;
  creditLife: 'yes'|'refuse'|'aged'|'own';
  journalComment?: string;
  userName?: string;
  secondMandateLoaded?: 'YES' | 'NO' | 'NOT_APPLICABLE';
  requiresManagerialApproval?: boolean;
  ltApprovalStatus?: 'pending' | 'verified' | 'approved' | 'rejected' | null;

}
